<template>
  <CardRow
    :label="label"
    :value="value"
    :disabled="disabled"
    :error-messages="errorMessages"
    :required="required"
    :hideBorderBottom="hideBorderBottom"
    :isDate="true"
  >
    <UIDatePickerMenu
      v-model="dataValue"
      hide-details
      :errorMessages="errorMessages"
      :placeholder="placeholder"
      :disabled="disabled"
      :limitMaxToMaxDictionaryYear="limitMaxToMaxDictionaryYear"
    />
  </CardRow>
</template>

<script>
import CardRow from './CardRow'
import { formatDateReverseFromISO } from '../../../scripts'
import UIDatePickerMenu from '../UIDatePickerMenu'

export default {
  name: 'CardDateRow',

  props: {
    label: String,
    value: {
      type: String | null,
      default: ''
    },
    type: {
      String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    hideBorderBottom: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Введите значение'
    },
    limitMaxToMaxDictionaryYear: {
      type: Boolean,
      default: false
    }
  },

  components: {
    UIDatePickerMenu,
    CardRow
  },

  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },

    formatDate() {
      return formatDateReverseFromISO(this.dataValue)
    }
  }
}
</script>

<style scoped></style>
